<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
        <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>

        <v-card class="shadow-none" v-if="!needInit">     
            <v-card-text v-if="myContent">                
                <div v-html="myContent.content"></div>
            </v-card-text>
        </v-card>
        <v-card class="shadow-none">
            <v-layout row wrap  align-center v-for="(item,index) in myList" :key="index"> 
                <v-flex xs11>
                    <v-layout row wrap align-center>
                        <v-flex xs1 :style="getMyStyle(item)" >
                            <v-layout justify-end v-if="status == 2">
                                <v-icon v-if="(myList[index] == myResult[index])"  v-bind:style="check_ok" >check_circle</v-icon>  
                                <v-icon v-if="(myList[index] != myResult[index])"  v-bind:style="check_error">error</v-icon>  
                            </v-layout>
                        </v-flex>
                        <v-flex xs11>
                            <drop @drop="handleDrop" :id="index">                       
                                <drag class="drag" :transfer-data="{ index: index }">
                                    <div :class="getMyStyle(item)" v-html="item" :id="index"></div>
                                </drag>                      
                            </drop>          
                        </v-flex> 
                    </v-layout>         
                </v-flex>
                <v-flex xs1>
                    <v-layout>
                        <v-icon v-if="index > 0" @click="moveUp(index)">arrow_circle_up</v-icon>
                        <v-icon v-if="index < myList.length-1" @click="moveDown(index)">arrow_circle_down</v-icon>
                    </v-layout>
                </v-flex>             
            </v-layout>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import { Drag, Drop } from 'vue-drag-drop';
import axios from '../../axios-auth.js'
import * as logs from '../../assets/log_process.js'


export default {   
    data() {
        return {
                myContent:  null,
                feedback: null,
                needInit : false,
                myList: [],
                check_ok : {
                    "color": "green",
                    "float": "left"
                },
                check_error : {
                    "color": "red",                    
                    "float": "left"
                },
                myResult: [],
                status: 0, // 0 no, 1 - show, 2 - check
                startTime : null

        }
    },
    components :{
        Drag,
        Drop
    },

    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    ])
    ,    
    props: { 
        dcontent: Object,
        taskIndex: Number,
        activity_type: String
    },
    methods: {
        initData() {            
            this.needInit = false         
            this.status = 0
            this.$store.commit('setFeedback', null)   
            this.myContent = (this.dcontent.data.content)            
            this.myList = this.myContent.codes

            // shuffle
            for(let i=0; i < this.myList.length; i++) {
                const rand = Math.floor(Math.random() * this.myList.length);
                [this.myList[i], this.myList[rand]] = [this.myList[rand], this.myList[i]];
                this.myResult.push('x')
            }                        
        },
        moveUp(_index) {
            this.status = 0 
            const _x = this.myList[_index]
            this.myList.splice(_index,1)
            this.myList.splice(_index-1,0,_x)
        },
        moveDown(_index) {
            this.status = 0 
            const _x = this.myList[_index]
            this.myList.splice(_index,1)
            this.myList.splice(_index+1,0,_x)
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent',false) 

            // send info to server
            const data = {
                task_id : this.dcontent.task_id,
                task_type_id: this.dcontent.task_type_id,
                time_length: Math.floor((new Date() - this.startTime)/1000 + 0.5),
                answer_list : JSON.stringify(this.myList),
                activity_type: this.activity_type
            }
          
            axios.post('/task-evaluate2', data, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useEvaluation(res.data)
                    console.log(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })           
        },
        useEvaluation(myData) {          
            this.$store.commit('setWaitingForResult',false) // data was delivered
        //    this.$store.commit('setTaskRating',myData.result.rating/20) // for backdrop
            this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: myData.result.rating})
            this.$store.commit('setUserPerformance',myData.user)

            for(let i = 0; i < this.myList.length; i++) {
                if (myData.result.answers[i] == 1) {
                    this.myResult[i] = '' + this.myList[i]
                } else {
                    this.myResult[i] = "error" + this.myList[i] 
                }
            } 

            this.status = 2
        },  
        showAnswer() {
            this.$store.commit('setShowAnswerEvent', false)
            
            axios.get('/get-my-answer/'+this.dcontent.task_id, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useAnswer(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })                                   
        },        
        useAnswer(myData) {
            this.myList = myData.answers
            this.$store.commit('setUserPerformance',myData.user)
        },          
        handleDrop(data, event) {
            // target         
            this.status = 0   
            let target_index = event.target.parentNode.id
            let source_index = data.index
            if (target_index == '') return 
            const insert = this.myList[source_index]
            this.myList.splice(source_index,1)
            this.myList.splice(target_index,0,insert)
        },
        getMyStyle(type) {
            if (type.substring(0,4) == '<pre') 
              return 'myCode'
            else return 'myParagraph'
        },
        getMyStyle2(type) {
            if (type == 'check_ok') 
              return 'check_ok'
            else return 'check_error'
        },        
    },
    mounted() {
        this.needInit = true
        this.startTime = new Date()
        logs.write_to_log('open', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, 0, this.$store.getters.getAxiosConfig)
    },
    beforeDestroy() {
        logs.write_to_log('close', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, Math.floor((new Date() - this.startTime)/1000 + 0.5), this.$store.getters.getAxiosConfig)
    }
}
</script>

<style>
.myCode {
	width: 100%;
	padding: 1px;
	margin: 1px;
	overflow: auto;
    cursor: move;
	overflow-y: hidden;
	font-size: 14px;
	line-height: 16px;
	background: #c7c1c156;
	border: 1px solid #777;
    font-family:'Courier New', Courier, monospace; 
    float: left;
}
.myParagraph {
	width: 100%;
	padding: 1px;
	margin: 1px;
    cursor: move;
	overflow: auto;
	overflow-y: hidden;
	font-size: 14px;
	line-height: 16px;
	border: 1px solid #777;
    float: left;
}


</style>